<template>
    <div>
        <v-container fluid>

            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                {{ snackbar_msg }}
                <v-btn dark text @click="snackbar = false">
                    Close
                </v-btn>
            </v-snackbar>

            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64" />
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>
                        Bus Tracking
                    </v-toolbar-title>
                </v-toolbar>

                <v-row justify="center" dense>

                    <v-col cols="12" sm="4">
                        <v-autocomplete v-model="child" :items="child_list" item-text="learner" item-value="id"
                            label="Child" outlined dense />
                    </v-col>

                    <v-col cols="12" sm="2" v-if="child">
                        <v-btn color="warning" @click="startTracking">
                            Track Bus
                        </v-btn>
                    </v-col>

                </v-row>
            </v-card>

            <v-card v-show="show_map" class="box mt-4 elevation-10 rounded-lg map" width="100%">
                <v-toolbar flat color="#0F2027" dark>
                    <v-icon class="mr-2" color="warning">mdi-bus-school</v-icon>

                    <v-toolbar-title> Live Bus Tracking</v-toolbar-title>

                    <v-spacer />

                    <v-btn icon @click="stopTracking">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <div id="live-tracking-map" style="height:500px;width:100%;border-radius:0 0 12px 12px;"></div>
            </v-card>

        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";

export default {

    data() {
        return {
            snackbar: false,
            snackbar_msg: "",
            color: "red",
            overlay: false,
            child: "",
            child_list: [],
            show_map: false,
            mapInstance: null,
            busMarker: null,
            trackingIntervalId: null,
            currentAddress: "Fetching location name..." 
        };
    },

    methods: {

        async startTracking() {
            this.stopTracking();
            await this.fetchBusLocation(true);

            this.trackingIntervalId = setInterval(async () => {
                await this.fetchBusLocation(false);
            }, 10000);
        },

        stopTracking() {

            if (this.trackingIntervalId) {
                clearInterval(this.trackingIntervalId);
                this.trackingIntervalId = null;
            }

            if (this.busMarker && this.mapInstance) {
                this.mapInstance.removeLayer(this.busMarker);
                this.busMarker = null;
            }

            this.show_map = false;
        },

        async fetchBusLocation(showOverlay = false) {

            if (showOverlay) {
                this.overlay = true;
            }

            try {
                const response = await axios.post("/ParentTransport/busTracking", { child: this.child });
                console.log("Tracking Response:", response.data);

                const latitude = response.data.latitude;
                const longitude = response.data.longitude;

                const validCoordinates = latitude !== null && latitude !== undefined && latitude !== "" && longitude !== null &&
                    longitude !== undefined && longitude !== "" && !isNaN(latitude) && !isNaN(longitude);

                if (response.data.flag === "YES" && validCoordinates) {
                    this.show_map = true;
                    await this.initializeMap();

                    await this.getLocationName(latitude, longitude);

                    this.updateMarker(parseFloat(latitude), parseFloat(longitude), response.data.vehicleNumber, response.data.dateTime);

                } else {
                    this.show_map = false;

                    if (this.busMarker && this.mapInstance) {
                        this.mapInstance.removeLayer(this.busMarker);
                        this.busMarker = null;
                    }

                    this.showSnackbar("#b71c1c", response.data.snackbar || "Bus location not available.");
                }

            } catch (error) {
                console.error(error);
                this.show_map = false;
                this.showSnackbar("#b71c1c", "Unable to fetch bus location.");

            } finally {
                this.overlay = false;
            }
        },

        async initializeMap() {
            await this.loadLeaflet();

            if (!this.mapInstance) {

                this.mapInstance = window.L.map(
                    "live-tracking-map",
                    {
                        attributionControl: false
                    }
                ).setView([18.5204, 73.8567], 16);

                window.L.tileLayer(
                    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                    {
                        maxZoom: 19
                    }
                ).addTo(this.mapInstance);

                setTimeout(() => {
                    if (this.mapInstance) {
                        this.mapInstance.invalidateSize();
                    }
                }, 300);
            }
        },

        async getLocationName(lat, lon) {
            try {
                const res = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`);
                this.currentAddress = res.data.display_name || "Location name found";
            } catch (e) {
                this.currentAddress = "Address name unavailable";
            }
        },

        // updateMarker(latitude, longitude, vehicleNumber, dateTime) {

        //     if (!this.mapInstance) {
        //         return;
        //     }

        //     const popupContent = `
        //         <div style="font-family: Arial, sans-serif; line-height: 1.4;">
        //             <b>Vehicle:</b> ${vehicleNumber || "-"}<br>
        //             <b>Location:</b> <span style="color: #2b6cb0;">${this.currentAddress}</span><br>
        //             <b>Updated:</b> ${this.formatDateTime(dateTime)}
        //         </div>
        //     `;

        //     if (this.busMarker) {

        //         this.busMarker.setLatLng([latitude, longitude]);

        //         if (this.busMarker.getPopup()) {
        //             this.busMarker.getPopup()
        //                 .setContent(popupContent);
        //         }

        //     } else {
        //         const busIcon = window.L.icon({
        //             iconUrl:
        //                 "https://cdn-icons-png.flaticon.com/512/3448/3448339.png",

        //             iconSize: [44, 44],
        //             iconAnchor: [22, 22],
        //             popupAnchor: [0, -18]
        //         });

        //         this.busMarker = window.L
        //             .marker(
        //                 [latitude, longitude],
        //                 { icon: busIcon }
        //             )
        //             .addTo(this.mapInstance);

        //         this.busMarker.bindPopup(
        //             popupContent, { maxWidth: 220 }
        //         );
        //     }

        //     this.mapInstance.flyTo(
        //         [latitude, longitude], 16, { animate: true, duration: 2 }
        //     );
        //     this.busMarker.openPopup();
        // },

        updateMarker(latitude, longitude, vehicleNumber, dateTime) {

            if (!this.mapInstance) {
                return;
            }

            const popupContent = `
                <div style="font-family: Arial, sans-serif; line-height: 1.4;">
                    <b>Vehicle:</b> ${vehicleNumber || "-"}<br>
                    <b>Location:</b> <span style="color: #2b6cb0;">${this.currentAddress}</span><br>
                    <b>Updated:</b> ${this.formatDateTime(dateTime)}
                </div>
            `;

            if (this.busMarker) {
                this.busMarker.setLatLng([latitude, longitude]);

                if (this.busMarker.getPopup()) {
                    this.busMarker.getPopup().setContent(popupContent);
                }

            } else {
                const busIcon = window.L.icon({
                    iconUrl: "https://cdn-icons-png.flaticon.com/512/3448/3448339.png",
                    iconSize: [44, 44],
                    iconAnchor: [22, 22],
                    popupAnchor: [0, -18]
                });

                this.busMarker = window.L
                    .marker([latitude, longitude], { icon: busIcon })
                    .addTo(this.mapInstance);

                this.busMarker.bindPopup(popupContent, { maxWidth: 220 });
                
                this.busMarker.openPopup();
            }

            this.mapInstance.panTo([latitude, longitude], { animate: true });
        },

        loadLeaflet() {
            return new Promise((resolve, reject) => {

                if (window.L) {
                    resolve();
                    return;
                }

                const css = document.createElement("link");
                css.rel = "stylesheet";
                css.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
                document.head.appendChild(css);

                const script = document.createElement("script");
                script.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";

                script.onload = () => resolve();

                script.onerror = () => reject(new Error("Leaflet failed to load"));

                document.head.appendChild(script);
            });
        },

        formatDateTime(dateTime) {
            if (!dateTime) return "-";

            return new Date(dateTime).toLocaleString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true
            });
        },

        onLoad() {

            axios
                .post("/ParentTransport/applyTransportFacility")
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.child_list = res.data.learner_list || [];

                        if (this.child_list.length === 1) {
                            this.child = this.child_list[0].id;
                            this.$nextTick(() => {
                                this.startTracking();
                            });
                        }
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason || "Unable to load children");
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong.");
                });
        },

        showSnackbar(color, message) {
            this.color = color;
            this.snackbar_msg = message;
            this.snackbar = true;
        }
    },

    mounted() {
        this.onLoad();
    },

    beforeDestroy() {
        this.stopTracking();

        if (this.mapInstance) {
            this.mapInstance.remove();
            this.mapInstance = null;
        }
    }
};
</script>

<style scoped>
.box {
    margin-top: 15px;
}

.map {
    height: 600px;
}

::v-deep .leaflet-control-attribution {
    display: none !important;
}
</style>